import React from 'react';
import { NavItemDef } from '../navItems';

export const DTBS_NAV_ITEMS: NavItemDef[] = [
  {
    key: 'dtb.library',
    label: 'dtbs.navItems.library',
    path: 'library',
    permissions: ['getDtbLibraryList'],
  },
  {
    key: 'dtb.packages',
    label: 'dtbs.navItems.packages',
    path: 'packages',
    permissions: ['listDtbPackages'],
  },
  {
    key: 'dtb.assignments',
    label: 'dtbs.navItems.assignments',
    path: 'assignments',
    permissions: ['assignDtbPackageToGroup'],
  },
  {
    key: 'dtb.distribution',
    label: 'dtbs.navItems.distribution',
    path: 'distribution',
    permissions: ['distributeDtbPackage'],
  },
];
